import React from 'react';
import { FilterProps } from '../index';
import { MainFiltersCard } from './common/MainFilterCard';
import { AlphabeticallyGroupedOptions } from './common/AlphabeticallyGroupedOptions';

export const PublishersFilter = (props: FilterProps) => (
  <MainFiltersCard title="Publishers" {...props}>
    <AlphabeticallyGroupedOptions {...props} key="PublishersFilter-container" />
  </MainFiltersCard>
);
